import { SUBSCRIPTION_BESTBUY_RENEWAL_CONVERSION_DAY } from "@/define";
import { useSubscriptionsStore } from "@/stores/subscriptions";
import { isNotActiveYet } from "@/common/subscriptionHelper";
import { useUserStore } from "@/stores/user";

export async function hasOnlyBestBuyS2(): Promise<boolean> {
  const userStore = useUserStore();
  const subscriptions = (await useSubscriptionsStore().getSubscriptions()) ?? [];
  if (subscriptions && subscriptions.length > 0) {
    const q = subscriptions.every(
      s =>
        s.keyCodeSellerType === "BestBuy" &&
        (s.expirationDays > SUBSCRIPTION_BESTBUY_RENEWAL_CONVERSION_DAY || isNotActiveYet(s))
    );
    return q;
  }
  return userStore.currentUser?.subscriberInfo?.hasBestBuyS2 ?? false;
}
